import React from "react";
import SheetViewport from "./SheetViewport";
import TitleBlock from "./TitleBlock";
import SheetFrame from "./SheetFrame";

export default function DrawingSheet({
  sheet,
  views,
  sheetZoom = 1,
  drawingTool,
  onCreateSectionFromView,
  dimensionDraft,
  onDimensionPick,
  activeViewportId,
  selectedViewportId,
  onSelectViewport,
  onMoveViewport,
  onResizeViewport,
  onUpdateViewport,
  onUpdateView,
  onActivateViewport,
  onDeactivateViewport,
  rootInstances,
  definitions,
  globalParameters,
  room,
  selectedRoomObjectId,
  onSelectRoomObject,
  selectedId,
  selectedIds,
  onMultiSelect,
  onSelect,
  onResolvedSelect,
  onDoubleOpen,
  onTransformNode,
  onChangeNode,
  materials,
  selectedAnnotationId,
  onSelectAnnotation,
  onUpdateAnnotation,
  onDeleteSelectedAnnotation,
}) {
  if (!sheet) {
    return (
      <div className="h-full grid place-items-center text-slate-500">
        No sheet selected.
      </div>
    );
  }

  const paper = sheet.paper || {
    widthMm: 420,
    heightMm: 297,
  };

  const BASE_PX_PER_MM = 3;
  const zoom = Number(sheetZoom || 1);

  // VAŽNO:
  // Sheet zoom više nije CSS transform.
  // Zoom sada ulazi direktno u pxPerMm.
  const pxPerMm = BASE_PX_PER_MM * zoom;

  const sectionViews = (views || []).filter((v) => v.type === "section");

  function getView(viewId) {
    return views.find((view) => String(view.id) === String(viewId)) || null;
  }

  return (
    <div
      className="relative bg-white shadow-xl"
      style={{
        width: paper.widthMm * pxPerMm,
        height: paper.heightMm * pxPerMm,
        position: "relative",
        isolation: "isolate",
      }}
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) {
          onSelectViewport?.(null);
          onDeactivateViewport?.();
        }
      }}
    >
      <SheetFrame
        paper={paper}
        pxPerMm={pxPerMm}
        marginMm={10}
        titleBlockWidthMm={170}
        titleBlockHeightMm={45}
      />

      {(sheet.viewports || []).map((viewport) => {
        const view = getView(viewport.viewId);

        return (
          <SheetViewport
            key={viewport.id}
            viewport={viewport}
            view={view}
            sheet={sheet}
            drawingTool={drawingTool}
            onCreateSectionFromView={onCreateSectionFromView}
            pxPerMm={pxPerMm}
            sheetZoom={1}
            sectionMarkers={sectionViews
              .filter(
                (sectionView) =>
                  sectionView.sectionPlane?.sourceViewId === view?.id
              )
              .map((sectionView) => ({
                viewId: sectionView.id,
                ...sectionView.sectionPlane,
              }))}
            selected={selectedViewportId === viewport.id}
            isActive={activeViewportId === viewport.id}
            onSelect={() => onSelectViewport?.(viewport.id)}
            onMoveViewport={onMoveViewport}
            onResizeViewport={onResizeViewport}
            onUpdateViewport={onUpdateViewport}
            onUpdateView={onUpdateView}
            onActivate={onActivateViewport}
            rootInstances={rootInstances}
            definitions={definitions}
            globalParameters={globalParameters}
            room={room}
            selectedRoomObjectId={selectedRoomObjectId}
            onSelectRoomObject={onSelectRoomObject}
            selectedId={selectedId}
            selectedIds={selectedIds}
            onMultiSelect={onMultiSelect}
            onSelectNode={onSelect}
            onResolvedSelect={onResolvedSelect}
            onDoubleOpen={onDoubleOpen}
            onTransformNode={onTransformNode}
            onChangeNode={onChangeNode}
            materials={materials}
            dimensionDraft={dimensionDraft}
            onDimensionPick={onDimensionPick}
            selectedAnnotationId={selectedAnnotationId}
            onSelectAnnotation={onSelectAnnotation}
            onUpdateAnnotation={onUpdateAnnotation}
          />
        );
      })}

      <TitleBlock
        data={sheet.titleBlock}
        paper={paper}
        pxPerMm={pxPerMm}
        marginMm={10}
        widthMm={170}
        heightMm={45}
      />
    </div>
  );
}